import {assert} from 'Asserts';

import areAminoAcidsValid from './areAminoAcidsValid';
import getAminoAcidFrequency from './getAminoAcidFrequency';

// From BioJava implementation:
// https://github.com/biojava/biojava/blob/master/biojava-aa-prop/src/main/java/org/biojava/nbio/aaproperties/PeptidePropertiesImpl.java#L194
function getExtinctAACount(aminoAcids: string): {C: number; Y: number; W: number} {
  const aminoAcidToCount = getAminoAcidFrequency(aminoAcids);

  return {
    // Count the occurrences of cystine which is a double cysteine bond
    C: Math.floor(aminoAcidToCount.get('C')! / 2),
    Y: aminoAcidToCount.get('Y')!,
    W: aminoAcidToCount.get('W')!,
  };
}

// From BioJava implementation:
// https://github.com/biojava/biojava/blob/02952752ada4ddc0e03ce8a4eea4d78d74192aef/biojava-aa-prop/src/main/java/org/biojava/nbio/aaproperties/Constraints.java#L299
const AA_TO_EXTINCTION_COEFFICIENT = {
  Y: 1490.0,
  W: 5500.0,
  C: 125.0,
};

export interface ExtinctionCoefficientOptions {
  assumeCysReduced: boolean;
}

// From BioJava implementation:
// https://github.com/biojava/biojava/blob/master/biojava-aa-prop/src/main/java/org/biojava/nbio/aaproperties/PeptidePropertiesImpl.java#L156
const _extinctionCoefficient = (
  aminoAcids: string,
  {assumeCysReduced}: ExtinctionCoefficientOptions
): number => {
  const upperAminoAcids = aminoAcids.toUpperCase();
  assert(areAminoAcidsValid(upperAminoAcids), 'Extinction coefficient requires valid amino acids.');

  const extinctAAToCount = getExtinctAACount(upperAminoAcids);

  let extinctionCoeff = 0;
  extinctionCoeff += extinctAAToCount.Y * AA_TO_EXTINCTION_COEFFICIENT.Y;
  extinctionCoeff += extinctAAToCount.W * AA_TO_EXTINCTION_COEFFICIENT.W;

  if (!assumeCysReduced) {
    extinctionCoeff += extinctAAToCount.C * AA_TO_EXTINCTION_COEFFICIENT.C;
  }

  return extinctionCoeff;
};

export default _extinctionCoefficient;
